import axios from 'axios'

export const getCategories = centerId => axios.get('/api/categories', { headers: { 'X-Center-Id': centerId } })
